import React from 'react';
import t from '~t';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { set } from '~data/actions/config';
import supported from '~assets/languages/index.json';

import { Label, Select } from '~ui';

export default function SettingsAppLang() {
  const lang = useSelector((state) => state.config.lang);
  const dispatch = useDispatch();

  const list = _.sortBy(Object.entries(supported), ([, label]) => label);

  return (
    <>
      <Label>{t.s('language')}</Label>
      <div className={'ui-lang'}>
        <Select
          autoFocus
          value={lang}
          onChange={(e) => dispatch(set('lang', e.target.value))}
        >
          {list.map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </Select>
      </div>
    </>
  );
}
